import { PegValues, PegResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculatePeg(values: PegValues, t?: ToolsTranslations['peg']): PegResult {
  const { pricePerShare, epsLatest, epsPrevious } = values;

  if (pricePerShare <= 0) {
    return { peg: null, pe: null, growthPercent: null, isValid: false, message: t?.invalid.pricePerShare ?? 'Pris per aktie måste vara större än 0' };
  }
  if (epsLatest <= 0) {
    return { peg: null, pe: null, growthPercent: null, isValid: false, message: t?.invalid.epsLatest ?? 'Senaste vinst per aktie måste vara större än 0' };
  }
  if (epsPrevious <= 0) {
    return { peg: null, pe: null, growthPercent: null, isValid: false, message: t?.invalid.epsPrevious ?? 'Föregående vinst per aktie måste vara större än 0' };
  }

  const pe = Math.round((pricePerShare / epsLatest) * 100) / 100;
  const growthPercent = Math.round(((epsLatest / epsPrevious - 1) * 100) * 100) / 100; // 2 decimals

  if (!isFinite(pe) || !isFinite(growthPercent)) {
    return { peg: null, pe: null, growthPercent: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }

  if (growthPercent === 0) {
    return { peg: null, pe, growthPercent, isValid: false, message: t?.invalid.zeroGrowth ?? 'Tillväxten är 0% vilket gör PEG omöjligt att beräkna' };
  }

  const pegRaw = pe / growthPercent;
  const peg = Math.round(pegRaw * 100) / 100;

  let interpretation = '';
  if (peg < 1) {
    interpretation = t?.additionalInfo?.undervalued ?? 'Undervärderat (< 1)';
  } else if (peg <= 1.2) {
    interpretation = t?.additionalInfo?.fairValue ?? 'Rättvärderat (~1)';
  } else {
    interpretation = t?.additionalInfo?.overvalued ?? 'Övervärderat (> 1)';
  }

  return { peg, pe, growthPercent, isValid: true, interpretation };
}


